export const INT_RADIX = 10;
export const TRUE_STRING = 'true';
export const ZERO_STRING = '0';
export const TOPIC_LAYER_VISITS_DEFAULT = 0;
export const FOLLOW_UP_PARENT_ELEMENTS_CHECK = 10;
export const WHITESPACE_REGEX = /\s+/g;
export const SPACE_CHARACTER = ' ';
export const CSS_SELECTOR_SEPARATOR = ',';
export const DAY = 1000 * 60 * 60 * 24;
export const HOURS = 1000 * 60 * 60;
export const MINUTES = 1000 * 60;
export const DEFAULT_LANGUAGE = 'en';

export const KEY_SPEECHBUBBLE_UNREAD_NOTIFICATIONS = 'cheverpush-speechbubble-unread-notifications';
export const KEY_HAS_UNREAD_NOTIFICATIONS = 'cp-has-unread-notifications';
export const KEY_UNREAD_NOTIFICATIONS_COUNT = 'cleverpush-unread-notifications';
export const KEY_DENY_COUNT = 'cleverpush-deny-count';
export const KEY_SUBSCRIPTION_STATUS = 'cleverpush-subscription-status';
export const KEY_UNREAD_NOTIFICATIONS_CLASS = 'cleverpush-unread-notifications-count';
export const KEY_FORCED_OPT_IN_RESET_AT = 'cleverpush-forced-opt-in-reset-at';

export const PANEL_TABS = Object.freeze({
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings'
});

export const SUBSCRIPTION_STATUS = {
  DENIED: 'denied',
  WAS_DENIED: 'was-denied',
  UNSUBSCRIBED: 'unsubscribed',
  PENDING: 'pending',
  ALLOWED: 'allowed',
};

export const TCF_MAX_RETRY_COUNT = 30;
export const TCF_RETRY_DELAY_MS = 500;
export const TCF_VERSION = 2;

// We only allow certain methods to prevent unwanted XSS
export const POST_MESSAGE_ALLOWED_METHODS = [
  'triggerFollowUpEvent',
  'trackEvent',
  'trackConversion',
  'tagSubscription',
  'untagSubscription',
  'setAttribute',
  'incAttribute',
  'pushAttributeValue',
  'pullAttributeValue',
  'subscribe',
  'triggerOptIn',
  'unsubscribe',
];
